/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pie_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep to a handful of slices for readability.`)
};

const es_pie_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limítate a un puñado de porciones para mayor legibilidad.`)
};

const de_pie_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschränken Sie sich für bessere Lesbarkeit auf eine Handvoll Segmente.`)
};

const nl_pie_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Houd het bij een handvol segmenten voor leesbaarheid.`)
};

const fr_pie_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limitez-vous à une poignée de secteurs pour la lisibilité.`)
};

const it_pie_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limita a poche fette per la leggibilità.`)
};

const pt_br2_pie_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantenha poucas fatias para melhor legibilidade.`)
};

const pt_pie_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantenha-se num punhado de fatias para melhor legibilidade.`)
};

const ja_pie_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読みやすさのため、スライスは少数に抑えてください。`)
};

const zh_pie_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为便于阅读，扇形数量应保持在少数几个以内。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pie_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pie_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pie_ex3", locale)
	if (locale === "en") return en_pie_ex3(inputs)
	if (locale === "es") return es_pie_ex3(inputs)
	if (locale === "de") return de_pie_ex3(inputs)
	if (locale === "nl") return nl_pie_ex3(inputs)
	if (locale === "fr") return fr_pie_ex3(inputs)
	if (locale === "it") return it_pie_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_pie_ex3(inputs)
	if (locale === "pt") return pt_pie_ex3(inputs)
	if (locale === "ja") return ja_pie_ex3(inputs)
	return zh_pie_ex3(inputs)
};